export function clamp(n, min, max) {
	if (n < min) {
		n = min;
	} else if (n > max) {
		n = max;
	}

	return n;
}
